import script from "./TheHeaderLogout.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeaderLogout.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeaderLogout.vue?vue&type=style&index=0&id=252b19ee&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252b19ee"]])

export default __exports__